import React from 'react';
import Header from './Header';
import useAppBranding from './Header/useAppBranding';
import { useConsumeWeaveTheme } from '../theme/WeaveContext';
export default function ChooseHeader({ branding, isTenantAware = true, helpUrl = 'https://help.autodesk.com/view/INF360I/ENU/', aboutBox, hasLoginPicker = false, inEmulation = false, notificationConfig, withHelpBot, }) {
    const _branding = useAppBranding(branding);
    const { isWeaveTheme } = useConsumeWeaveTheme();
    const realBranding = React.useMemo(() => {
        console.debug('Brand Config:', { isWeaveTheme, branding });
        if (branding)
            return branding;
        if (isWeaveTheme)
            return _branding;
        return 'info360';
    }, [isWeaveTheme, _branding, branding]);
    return (React.createElement(Header, { branding: realBranding, isTenantAware: isTenantAware, helpUrl: helpUrl, aboutBox: aboutBox, hasLoginPicker: hasLoginPicker, inEmulation: inEmulation, notificationConfig: notificationConfig, withHelpbot: withHelpBot }));
}
